var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.5H24C24.2761 7.5 24.5 7.72385 24.5 8V13C24.5 13.2762 24.2761 13.5 24 13.5H8C7.72385 13.5 7.5 13.2762 7.5 13V8C7.5 7.72385 7.72385 7.5 8 7.5ZM6 8C6 6.89542 6.89543 6 8 6H24C25.1046 6 26 6.89542 26 8V13C26 14.1046 25.1046 15 24 15H8C6.89543 15 6 14.1046 6 13V8ZM8 18.5H15C15.2761 18.5 15.5 18.7238 15.5 19V24C15.5 24.2762 15.2761 24.5 15 24.5H8C7.72385 24.5 7.5 24.2762 7.5 24V19C7.5 18.7238 7.72385 18.5 8 18.5ZM6 19C6 17.8954 6.89543 17 8 17H15C16.1046 17 17 17.8954 17 19V24C17 25.1046 16.1046 26 15 26H8C6.89543 26 6 25.1046 6 24V19ZM24.5 19C24.5 18.7238 24.2761 18.5 24 18.5H21C20.7239 18.5 20.5 18.7238 20.5 19V24C20.5 24.2762 20.7239 24.5 21 24.5H24C24.2761 24.5 24.5 24.2762 24.5 24V19ZM21 17C19.8954 17 19 17.8954 19 19V24C19 25.1046 19.8954 26 21 26H24C25.1046 26 26 25.1046 26 24V19C26 17.8954 25.1046 17 24 17H21ZM22.5 12C22.7761 12 23 11.7762 23 11.5C23 11.2238 22.7761 11 22.5 11C22.2239 11 22 11.2238 22 11.5C22 11.7762 22.2239 12 22.5 12Z",
    fill: "currentColor",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPage);
export default __webpack_public_path__ + "static/media/ContentPage.85300cda.svg";
export { ForwardRef as ReactComponent };